import ReportTracingAbility from '@/models/ReportTracingAbility/ReportTracingAbility';

export default class ReportTracingAbilityFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterControlCard = '';
		this.filterTransactionType = '';
		this.filterCreatedDateFrom = '';
		this.filterCreatedDateTo = '';
		this.tempId = '';
		this.controlCardType = '';
		this.controlCardNumber = '';
		this.partNumber = '';
		this.customerName = '';
		this.supplierCode = '';
		this.incomingDateFrom = '';
		this.incomingDateTo = '';
		this.transactionDateFrom = '';
		this.transactionDateTo = '';
		this.transactionType = '';
		this.qtyBefore = '';
		this.qtyAfter = '';
		this.rackBefore = '';
		this.rackAfter = '';
		this.areaBefore = '';
		this.areaAfter = '';
		this.sourceCase = '';
		this.statuss = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterControlCard : '0',
			filterTransactionType : '0',
			filterCreatedDateFrom : '0',
			filterCreatedDateTo : '0',
			tempId : '0',
			controlCardType : '0',
			controlCardNumber : '0',
			partNumber : '0',
			customerName : '0',
			supplierCode : '0',
			incomingDateFrom : '0',
			incomingDateTo : '0',
			transactionDateFrom : '0',
			transactionDateTo : '0',
			transactionType : '0',
			qtyBefore : '0',
			qtyAfter : '0',
			rackBefore : '0',
			rackAfter : '0',
			areaBefore : '0',
			areaAfter : '0',
			sourceCase : '0',
			statuss : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}